import { Injectable, inject } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { from, Observable } from "rxjs";
import { MinaMaskinlagComponent } from "./mina-maskinlag.component";

@Injectable({
    providedIn: "root"
})
export class MinaMaskinlagDialogService {
    private readonly ngbModalService = inject(NgbModal);

    minaMaskinlagModal(): Observable<any> {
        if (!this.ngbModalService.hasOpenModals()) {
            const modalRef = this.ngbModalService.open(MinaMaskinlagComponent, {
                keyboard: false,
                backdrop: "static",
                size: "lg"
            });
            modalRef.componentInstance.isModalActive = true;
            return from(modalRef.result);
        }

        return from(null);
    }
}
